import { ToastContainer } from 'react-toastify';

import { UserProvider } from '@engecomp/shared/contexts';
import { ClientBuilder } from '@engecomp/shared/services';

import { Router } from './router';

import 'react-toastify/dist/ReactToastify.css';

export function App() {
  ClientBuilder({ apiURL: process.env.API_URL, cdnURL: process.env.CDN_URL });

  return (
    <>
      <UserProvider>
        <Router />
      </UserProvider>

      <ToastContainer
        autoClose={5000}
        rtl={false}
        newestOnTop={false}
        hideProgressBar={false}
        position='bottom-left'
        theme='light'
        draggable
        pauseOnHover
        closeOnClick
        pauseOnFocusLoss
      />
    </>
  );
}
